import styled from 'styled-components'

import { theme } from '../../../../styles/theme'

export const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 30px;
  padding: 12px 0px;
  background-color: ${theme.colors.green2};
  color: ${theme.colors.white};
  border-radius: ${theme.border.smallRadius};
  font-weight: ${theme.font.bold};
  text-decoration: none;

  @media (min-width: 768px) {
    width: 20%;

    margin: 0 auto;
    margin-top: 24px;
  }
`
